import React from "react";
import "../../App.css";
import i18next from "../../i18n";
import { Helmet } from "react-helmet-async";
import Button from "../../components/Button";
import EAA_logo from "../../images/EAA.png";
import article_img_3 from "../../images/articles/people-mobile.jpg";

function KommunikasjonSomByggerTillit() {
  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>{i18next.t("pages.articles.list.ccm.title")}</title>
        <meta
          name="description"
          content={i18next.t("pages.articles.list.ccm.description")}
        />
        <link
          rel="canonical"
          href="https://xperconsulting.no/artikler/kommunikasjon-som-bygger-tillit"
        />
      </Helmet>
      <div className="container max-w-xl pt-36 justify-start items-center text-main-dark flex flex-col md:flex-row pb-24 md:gap-16">
        <div className="w-full md:w-3/5 text-left  ">
          <h1 className="text-5xl font-bold text-main-dark mb-2">
            {i18next.t("pages.articles.list.ccm.title")}
          </h1>
          <p className="text-xl mb-2">
            {i18next.t("pages.articles.list.ccm.description")}
            <a href="/ccm" className=" underline hover:text-contrast-ink"> {i18next.t("pages.articles.list.ccm.link")}</a>
            {i18next.t("pages.articles.list.ccm.description2")}
          </p>
          <p className="text-lg text-secondary">
            {i18next.t("pages.articles.list.ccm.date")}
          </p>
        </div>
        <div className="w-full md:w-2/5 text-left">
          <img
            className="w-full h-full object-cover"
            src={article_img_3}
            alt={i18next.t("pages.articles.list.ccm.imageAlt")}
          />
        </div>
      </div>
      <div className="bg-gray">
        <div className="container max-w-xl text-xl text-left py-24 text-main-dark">
          <div className=" max-w-sm">
            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.ccm.sections.what.title")}
            </h2>
            <p className="mb-4">
              {i18next.t("pages.articles.list.ccm.sections.what.content")}
            </p>
            <ul className="list-disc list-outside mb-6 ml-6">
              <li>
                {i18next.t("pages.articles.list.ccm.sections.what.features.1")}
              </li>
              <li>
                {i18next.t("pages.articles.list.ccm.sections.what.features.2")}
              </li>
              <li>
                {i18next.t("pages.articles.list.ccm.sections.what.features.3")}
              </li>
              <li>
                {i18next.t("pages.articles.list.ccm.sections.what.features.4")}
              </li>
            </ul>
            <p>
              {i18next.t("pages.articles.list.ccm.sections.what.conclusion")}
            </p>
            <p>
              <a className=" underline hover:text-contrast-ink" href="/ccm">
                {i18next.t("pages.articles.list.ccm.sections.what.cta")}
              </a>
            </p>
            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.ccm.sections.why.title")}
            </h2>
            <p>{i18next.t("pages.articles.list.ccm.sections.why.content")}</p>
            <p className="mb-4">
              {i18next.t("pages.articles.list.ccm.sections.why.withCCM")}
            </p>
            <ul className="list-disc list-outside mb-6 ml-6">
              <li>
                {i18next.t("pages.articles.list.ccm.sections.why.features.1")}
              </li>
              <li>
                {i18next.t("pages.articles.list.ccm.sections.why.features.2")}
              </li>
              <li>
                {i18next.t("pages.articles.list.ccm.sections.why.features.3")}
              </li>
              <li>
                {i18next.t("pages.articles.list.ccm.sections.why.features.4")}
              </li>
            </ul>
            <h2 className="text-3xl font-bold mt-12 mb-4">
              {i18next.t("pages.articles.list.ccm.sections.xper.title")}
            </h2>
            <p className="mb-4">
              {i18next.t("pages.articles.list.ccm.sections.xper.content")}
            </p>
            <ul className="list-disc list-outside mb-4 ml-6">
              <li>
                {i18next.t("pages.articles.list.ccm.sections.xper.features.1")}
              </li>
              <li>
                {i18next.t("pages.articles.list.ccm.sections.xper.features.2")}
              </li>
              <li>
                {i18next.t("pages.articles.list.ccm.sections.xper.features.3")}
              </li>
              <li>
                {i18next.t("pages.articles.list.ccm.sections.xper.features.4")}
              </li>
            </ul>
            <p>
              {i18next.t("pages.articles.list.ccm.sections.xper.conclusion")}
            </p>
            <p>{i18next.t("pages.articles.list.ccm.sections.cta.question")}</p>
            <p>{i18next.t("pages.articles.list.ccm.sections.cta.content")}</p>
            <p>
              {" "}
              <a
                className="text-contrast-ink underline underline-offset-2"
                href="/skjema/kontakt-oss"
              >
                {i18next.t("pages.articles.list.ccm.sections.cta.cta")}
              </a>
              {i18next.t("pages.articles.list.ccm.sections.cta.ctaFollow")}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default KommunikasjonSomByggerTillit;
